import { Injectable } from '@angular/core'

import { MenuItem, PathNode } from '@mprep/shared/data/models'
import { AppStateService } from '../../app-state'

@Injectable()
export class MenuItemFactory {
  constructor(
    private _appStateService: AppStateService
  ) {}

  public createSection(title: string) {
    return this._createMenuItem({
      title: title,
      icon: ''
    })
  }

  public createBlankSection() {
    return this.createSection('')
  }

  public createHome() {
    return this._createMenuItem({
      title: this._appStateService.path.title,
      icon: 'fa-home',
      styles: [ 'workspace' ],
      action: {
        type: 'function',
        value: 'navigateBackToWorkspace'
      }
    })
  }

  public createStarredTasks(pathId) {
    return this._createMenuItem({
      title: 'Starred Tasks',
      icon: 'fa-star',
      styles: [ 'starred-tasks' ],
      action: {
        type: 'routerlink',
        value: [ `/path/${pathId}/starred-tasks` ]
      }
    })
  }

  public createGlobalMenuItems() {
    return [
      this._createMenuItem({
        title: 'Help',
        icon: 'fa-question-circle',
        action: {
          type: 'url',
          value: '//www.manhattanprep.com/support/'
        }
      }),
      this.createLogout()
    ]
  }

  public createTour(tourFunctionName: string) {
    return this._createMenuItem({
      title: 'Launch Tour',
      icon: 'fa-map',
      action: {
        type: 'function',
        value: tourFunctionName
      }
    })
  }

  public createLogout() {
    return this._createMenuItem({
      title: 'Logout',
      icon: 'fa-sign-out',
      action: {
        type: 'function',
        value: 'logout'
      }
    })
  }

  public createSyllabusReset(pathRoot: PathNode) {
    return this._createMenuItem({
      title: 'Reset Syllabus',
      icon: 'fa-history',
      action: {
        type: 'function',
        value: 'resetPath',
        args: [pathRoot]
      }
    })
  }

  public createSyllabusSwitch() {
    return this._createMenuItem({
      title: 'Switch Syllabus',
      icon: 'fa-refresh',
      action: {
        type: 'function',
        value: 'switchSyllabus'
      }
    })
  }

  private _createMenuItem(options): MenuItem {
    const item = new MenuItem()
    Object.keys(options).forEach((key) => {
      item[key] = options[key]
    })
    return item
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/menu/menu-item-factory/menu-item.factory.ts